import z from 'zod';
import { FanforgeUserJwtClaimsBaseSchema } from './fanforge-user-jwt-claims-base';

export const FanforgeUserJwtClaimsDiscordSchema = FanforgeUserJwtClaimsBaseSchema.extend({
  amr: z.literal('discord'), // authentication methods reference
  username: z.string(),
  discordId: z.string().nullable(),
  guildId: z.string().nullable(),
  channelId: z.string().nullable(),
  instanceId: z.string(),
  avatarUrl: z.string().url(),
});

export type FanforgeUserJwtClaimsDiscord = z.infer<typeof FanforgeUserJwtClaimsDiscordSchema>;
